export const columns = [
  {Header: 'גוש וחלקה', accessor: 'gushHelkaTtHelka'},
  {Header: 'תאריך עסקה', accessor: 'saleDate'},
  {Header: 'יישוב', accessor: 'city'},
  {Header: 'רחוב', accessor: 'street'},
  {Header: 'בית', accessor: 'houseNumber'},
  {Header: 'כניסה', accessor: 'entranceNumber'},
  {Header: 'דירה', accessor: 'apartmentNumber'},
  {Header: 'מחיר מוצהר', accessor: 'salePrice'},
  {Header: 'מחיר מוערך', accessor: 'estimatePrice'},
  {Header: 'סוג שטח ברוטו', accessor: 'brutoAreaType'},
  {Header: 'שטח ברוטו', accessor: 'brutoAreaInSquareMeters'},
  {Header: 'סוג שטח נטו', accessor: 'netAreaType'},
  {Header: 'שטח נטו', accessor: 'netAreaInSquareMeters'},
  {Header: 'שנת בנייה', accessor: 'buildYear'},
  {Header: 'מחיר לחדר', accessor: 'pricePerRoom'},
  {Header: 'מחיר למטר', accessor: 'pricePerSquareMeter'},
  {Header: 'מספר חדרים', accessor: 'roomCount'},
  {Header: 'קומה', accessor: 'floor'},
  {Header: 'מספר קומות', accessor: 'floorsCount'},
  {Header: 'מספר דירות בבניין', accessor: 'roomsCount'},
  {Header: 'חניה', accessor: 'parking'},
  {Header: 'מעלית', accessor: 'elevator'},
  {Header: 'גג', accessor: 'roof'},
  {Header: 'מחסן', accessor: 'storage'},
  {Header: 'חצר', accessor: 'yard'},
  {Header: 'מגרש', accessor: 'lot'},
  {Header: 'גלריה', accessor: 'gallery'},
  {Header: 'סוג עסקה', accessor: 'sellType'},
  {Header: 'תפקוד יחידה', accessor: 'propertyType'},
  {Header: 'חלקים', accessor: 'soldShare'},
  {Header: 'מהות זכות', accessor: 'essenseOfRight'},
  {Header: 'תפקוד בניין', accessor: 'buildingUnitFunction'},
  {Header: 'שטח לחדר', accessor: 'areaRooms'},
  {Header: 'התאמת מחיר לפי חלק נמכר', accessor: 'salePriceSoldShare'},
];